import type { Area } from "~/types";

export default async function () {
  const store = useState<Area[]>("area", () => []);

  if (0 === store.value.length) {
    const res = await useFetch("/api/sekou/area");
    if (res && res.data && res.data.value) {
      store.value = res.data.value;
    }
  }
  return store;
}
